import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useAuth } from './auth-context';

const BalanceContext = createContext(null);

export function BalanceProvider({ children }) {
    const { user, isLoading: isAuthLoading, refreshUser } = useAuth();
    const [balance, setBalance] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    // Synchroniser la balance avec les données utilisateur du contexte auth
    useEffect(() => {
        if (isAuthLoading) return;

        if (user) {
            const tokenBalance = user?.personal_token_balance ?? user?.balance ?? null;
            setBalance(tokenBalance);
        } else {
            setBalance(null);
        }
        setIsLoading(false);
    }, [user, isAuthLoading]);

    // refreshBalance utilise maintenant refreshUser de auth-context
    const refreshBalance = useCallback(async () => {
        try {
            const userData = await refreshUser(true);
            const tokenBalance = userData?.personal_token_balance ?? userData?.balance ?? null;
            setBalance(tokenBalance);
            return tokenBalance;
        } catch {
            return null;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <BalanceContext.Provider value={{ balance, isLoading, refreshBalance }}>{children}</BalanceContext.Provider>;
}

export function useBalance() {
    const context = useContext(BalanceContext);
    if (!context) {
        throw new Error('useBalance must be used within a BalanceProvider');
    }
    return context;
}
